import { MapDataService } from '@ui/shared/domain-map';
import { map, type Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import {
    MobilityMapService,
} from '@ui/shared/util-api';
import { MobilityMapItem } from '../../definitions/mobility-map-item';
import type { MobilityMapFilter } from '../../types/mobility-map-filters';
import { toRequestQuery } from '@ui/shared/util-filter';

@Injectable({ providedIn: 'root' })
export class ProjectsMapDataService extends MapDataService<MobilityMapItem, MobilityMapFilter> {
    protected _api = inject(MobilityMapService);

    public getData$(filter: MobilityMapFilter): Observable<Array<MobilityMapItem>> {
        return this._api.getAllMobilityProjects({
            search: typeof filter.search === 'string' ? filter.search : null,
            categoryIds: toRequestQuery(filter.categories),
            transportationTypeIds: toRequestQuery(filter.transportationTypes),
            guidingThemeIds: toRequestQuery(filter.guidingThemes),
        })
            .pipe(map(response => response.data.map(dto => new MobilityMapItem(dto))));
    }
}
